<template>
  <div>
    <div class="lg:mt-24 md:mt-24 mt-10 lg:flex md:flex gap-5">
      <p
        class="fsize30 sm-fsize20 font-semibold lg:pr-24 md:pr-24 pr-0 lg:pr-24 md:pr-24 pr-0 text-232323 lg:mb-2 md:mb-2 mb-2 cust-text-center lg:mt-0 md:mt-0 mt-2 web-hidden"
      >
        THE FIRE TRIO
      </p>
      <div
        id="6135426701"
        class="lg:w-1/2 md:w-1/2 w-full hoverText1 lg:mb-0 md:mb-0 mb-5 lg:mt-0 md:mt-0 mt-3"
      >
        <img
          :src="getImage(pageData['6135426701'])"
          alt="acp icon"
          class="h-250 sm-h-150px object-contain w-full"
        />
      </div>

      <div class="lg:w-1/2 md:w-1/2 w-full flex flex-col lg:mb-0 md:mb-0 mb-4">
        <h4
          id="8799412602"
          class="fsize24 sm-fsize20 font-semibold hoverText1 lg:pr-24 md:pr-24 pr-0 lg:pr-24 md:pr-24 pr-0 text-232323 lg:mb-2 md:mb-2 mb-2 cust-text-center lg:mt-0 md:mt-0 mt-2 md:block mob-hidden"
        >
          {{ pageData ? pageData["8799412602"] : "THE FIRE TRIO" }}
        </h4>

        <p
          id="0205427122"
          class="text-justify fsize18 hoverText1 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
          v-html="
            pageData
              ? pageData['0205427122']
              : 'Fuel, oxygen and heat are the deadly trio that leads to the ignition of fire, The best way to prevent the fire is to break just one element out of the three, EUROBOND FR Panels do just that by eliminating the fuel and replacing combustible LDPE core with non-combustible Core. Thus, preventing the spread of fire.'
          "
        ></p>
      </div>
    </div>
    <div class="lg:mt-24 md:mt-16 mt-5 lg:flex gap-5">
      <div class="lg:w-1/2 md:w-full w-full">
        <div class="g:flex md:flex gap-2 lg:flex-row md:flex-row-reverse">
          <div id="8927000848" class="hoverText1 lg:w-full md:w-1/2">
            <img
              :src="getImage(pageData['8927000848'])"
              alt="acp icon"
              class="h-250 sm-h-150px object-contain w-full md:block mob-hidden"
            />
          </div>
          <div class="lg:mb-0 md:mb-0 mb-4 lg:w-full md:w-1/2">
            <p
              id="4223807936"
              class="fsize24 sm-fsize20 hoverText1 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 cust-text-center lg:mt-0 md:mt-0 mt-2"
            >
              {{ pageData ? pageData["4223807936"] : "ORDINARY CLADDING" }}
            </p>
            <div class="web-hidden">
              <img
                src="@/assets/images/Group 10172.png"
                alt="acp icon"
                class="h-250 sm-h-150px object-contain w-full"
              />
            </div>
            <ul
              id="2860546339"
              style="list-style-type: disc"
              class="hoverText1 fsize18 lg:pt-0 md:pt-0 pt-4 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
              v-html="
                pageData
                  ? pageData['2860546339']
                  : 'Fire spreads upwards and downwards due to flaming droplets Fire breaks in and out through glass Toxic smoke builds up leading to more casualties and disrupting the smooth evacuation process'
              "
            ></ul>
          </div>
        </div>
      </div>
      <div class="lg:w-1/2 md:w-full w-full lg:mt-0 md:mt-10">
        <div class="lg:flex md:flex gap-2">
          <div id="2941559355" class="hoverText1 lg:w-full md:w-1/2">
            <img
              :src="getImage(pageData['2941559355'])"
              alt="acp icon"
              class="h-250 sm-h-150px object-contain w-full lg:mt-0 md:mt-0 mt-10 md:block mob-hidden"
            />
          </div>
          <div class="lg:mb-0 md:mb-0 mb-4 lg:w-full md:w-1/2">
            <p
              id="6602488127"
              class="fsize24 sm-fsize20 hoverText1 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 cust-text-center lg:mt-0 md:mt-0 mt-2"
            >
              {{ pageData ? pageData["6602488127"] : "EUROBOND FR PANELS" }}
            </p>
            <div class="web-hidden">
              <img
                src="@/assets/images/Group 10173.png"
                alt="acp icon"
                class="h-250 sm-h-150px object-contain w-full lg:mt-0 md:mt-0 mt-10"
              />
            </div>
            <ul
              id="7981985006"
              style="list-style-type: disc"
              class="hoverText1 fsize18 col-3535 sm-fsize14 lg:mb-4 md:mb-4 mb-4"
              v-html="
                pageData
                  ? pageData['7981985006']
                  : ' Fire spreads upwards is restricted due to fire Retardant Cladding that is non-combustible No droplets fall down avoiding further spread of fire No toxic smoke Safer evacuation saving more life and property'
              "
            ></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },
  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["FR ACP"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },

  methods: {
    getImage(image) {
      if (image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },

    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },

    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["FR ACP"];
    }

    if (this.$route.query.token === "123") {
      console.log("CMS Active");
      await this.addClass();
    } else {
      await this.removeClass();
    }
  },
};
</script>
<style>
.h-250 {
  height: 250px;
}
@media (max-width: 640px) {
  .sm-h-150px {
    height: 150px;
  }
  .cust-text-center {
    text-align: center;
  }
}
</style>
